import React from "react";
import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import { useTranslation } from "react-i18next";

export default function CallToAction() {
  const { t } = useTranslation("home");
  const navigate = useNavigate();

  return (
    <Box
      id="contact"
      sx={{
        position: "relative",
        overflow: "hidden",
        background: "linear-gradient(120deg,#1FC0DA,#4B78EC 48%,#7A3FE4)",
        py: { xs: "52px", md: "60px" },
        px: { xs: 3, md: "56px" },
      }}
    >
      {/* Subtle radial glows */}
      <Box sx={{
        position: "absolute", inset: 0, pointerEvents: "none",
        background: "radial-gradient(60% 130% at 12% -10%,rgba(255,255,255,.20),transparent 55%),radial-gradient(50% 120% at 100% 120%,rgba(255,255,255,.10),transparent 60%)",
      }} />

      <Box sx={{
        position: "relative",
        maxWidth: 1320,
        mx: "auto",
        display: "flex",
        alignItems: "center",
        gap: "32px",
        flexWrap: "wrap",
      }}>
        <Box sx={{ flex: 1, minWidth: "280px" }}>
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: "1.75rem", md: "2.125rem" },
              fontWeight: 800,
              letterSpacing: "-.02em",
              color: "#fff",
              fontFamily: "var(--font-display)",
              lineHeight: 1.15,
              m: 0,
            }}
          >
            {t("ctaHeadline")}
          </Typography>
          <Typography sx={{
            fontSize: "16px", color: "rgba(255,255,255,.85)",
            mt: "10px", fontFamily: "var(--font-ui)", lineHeight: 1.6,
          }}>
            {t("ctaSubtext")}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", gap: "14px", flexShrink: 0, flexWrap: "wrap" }}>
          <Box
            component="button"
            onClick={() => navigate("/signup")}
            sx={{
              height: 52, px: "28px", borderRadius: "999px",
              border: "none", cursor: "pointer",
              background: "#fff",
              fontFamily: "var(--font-ui)", fontWeight: 700, fontSize: "16px",
              color: "#6D28D9",
              boxShadow: "0 10px 24px rgba(0,0,0,.16)",
              transition: "transform 0.18s ease, filter 0.18s ease",
              "&:hover": { transform: "translateY(-2px)", filter: "brightness(1.04)" },
              "&:active": { transform: "translateY(0)" },
            }}
          >
            {t("heroStartFree")}
          </Box>
          <Box
            component="button"
            onClick={() => navigate("/offers")}
            sx={{
              height: 52, px: "28px", borderRadius: "999px",
              border: "1px solid rgba(255,255,255,.6)", background: "transparent",
              cursor: "pointer",
              fontFamily: "var(--font-ui)", fontWeight: 600, fontSize: "16px",
              color: "#fff",
              transition: "transform 0.18s ease, background 0.15s ease",
              "&:hover": { transform: "translateY(-1px)", background: "rgba(255,255,255,.08)" },
              "&:active": { transform: "translateY(0)" },
            }}
          >
            {t("heroBookDemo")}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
